import { getSerializedData } from '@jaredpalmer/after';
import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import { IS_SERVER, GRAPHQL_CLIENT_URL } from '../config';

export default () => {
  if (IS_SERVER) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const fetch = require('cross-fetch');

    return new ApolloClient({
      ssrMode: IS_SERVER,
      link: new HttpLink({
        uri: GRAPHQL_CLIENT_URL,
        fetch,
      }),
      cache: new InMemoryCache(),
    });
  }

  return new ApolloClient({
    uri: GRAPHQL_CLIENT_URL,
    cache: new InMemoryCache().restore(getSerializedData('apolloState')),
  });
};
